var React = require('react');

function FlagEsCn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M256 0H0v172h256V0z","fill":"#FC0","key":0}),React.createElement("path",{"d":"M170.667 0H0v172h170.667V0z","fill":"#0768A9","key":1}),React.createElement("path",{"d":"M85.333 0H0v172h85.333V0z","fill":"#fff","key":2})]);
}

FlagEsCn.defaultProps = {"fill":"none","viewBox":"0 0 256 172"};

module.exports = FlagEsCn;

FlagEsCn.default = FlagEsCn;
